
export const LEAVE_VISIT_EVENT = 'leave-visit';
export const VISIT_END_EVENT   = 'visit-end';
export const AUDIO_RECEIVED_EVENT = 'audio-received';
export const VIDEO_RECEIVED_EVENT   = 'video-received';